'use strict';

import { Entity } from '../Entity';

export class GlobCompanies extends Entity {
  protected companyId;

  protected companyName;

  protected companyPolicyType;

  protected companyRenewalPayment = 'E';

  protected companyOrg;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.companyId = data.companyId;

    this.companyName = data.companyName;

    this.companyPolicyType = data.companyPolicyType;

    this.companyRenewalPayment = data.companyRenewalPayment;

    this.companyOrg = data.companyOrg;
  }

  public getCompanyId() {
    return this.companyId;
  }

  public setCompanyId(companyId) {
    this.companyId = companyId;

    return this;
  }

  public getCompanyName() {
    return this.companyName;
  }

  public setCompanyName(companyName) {
    this.companyName = companyName;

    return this;
  }

  public getCompanyPolicyType() {
    return this.companyPolicyType;
  }

  public setCompanyPolicyType(companyPolicyType) {
    this.companyPolicyType = companyPolicyType;

    return this;
  }

  public getCompanyRenewalPayment() {
    return this.companyRenewalPayment;
  }

  public setCompanyRenewalPayment(companyRenewalPayment) {
    this.companyRenewalPayment = companyRenewalPayment;

    return this;
  }

  public getCompanyOrg() {
    return this.companyOrg;
  }

  public setCompanyOrg(companyOrg) {
    this.companyOrg = companyOrg;

    return this;
  }
}
